import { Injectable } from '@angular/core';
import { isNullOrUndefined } from 'util';


@Injectable()
export class BrowserNotificationService {

	public notificationsPossible(): boolean {
		return !isNullOrUndefined(Notification);
	}

	public createNotification(title: string = '', content: string = '', iconPath: string = ''): Notification {
		if (this.notificationsPossible()) {
			return new Notification(title, {
				body: content,
				icon: iconPath
			});
		}

		return null;
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/browser-notification/browser-notification.service.ts